import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M9.99199 18.3334C5.39071 18.3288 1.66393 14.5958 1.66699 9.99453C1.67006 5.39324 5.40182 1.66522 10.0031 1.66675C14.6044 1.66828 18.3337 5.39879 18.3337 10.0001C18.3309 14.6046 14.5965 18.3353 9.99199 18.3334ZM3.33366 10.1434C3.37309 13.8111 6.36792 16.758 10.0358 16.7384C13.7036 16.7186 16.6666 13.7397 16.6666 10.0717C16.6666 6.40383 13.7036 3.42489 10.0358 3.40508C6.36792 3.38546 3.37309 6.33238 3.33366 10.0001V10.1434ZM10.8337 14.1667H9.16699V12.5001H10.8337V14.1667ZM10.8337 10.8334H9.16699V5.83341H10.8337V10.8334Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "InfoWarning"
);
